import { render, staticRenderFns } from "./ReportBody.vue?vue&type=template&id=2d1e5823&scoped=true&"
import script from "./ReportBody.vue?vue&type=script&lang=js&"
export * from "./ReportBody.vue?vue&type=script&lang=js&"
import style0 from "./ReportBody.vue?vue&type=style&index=0&id=2d1e5823&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1e5823",
  null
  
)

export default component.exports
import {QExpansionItem,QItemSection,QIcon,QItem,QInput,QBtn,QTooltip,QCheckbox} from 'quasar'
component.options.components = Object.assign({QExpansionItem,QItemSection,QIcon,QItem,QInput,QBtn,QTooltip,QCheckbox}, component.options.components || {})
